import React from 'react';

const Row = ({ country, cpc }) => {

    return (
        <tr>
            <td>{country}</td>
            <td>{cpc}</td>
        </tr>
    );
};

export default Row;



// WEBPACK FOOTER //
// ./src/scenes/PushapiCpcAll/components/Table/components/Row/index.js